import React, { useState, useEffect, useMemo, useCallback } from 'react';
import _ from 'lodash';
import { useSnapshot } from 'valtio';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Spinner,
  UncontrolledTooltip,
  Tooltip,
  TabPane,
} from 'reactstrap';
import Select from 'react-select';
import { cn } from 'lib/utils';
import { optimizationState } from '../state';
import { parseNumericValue } from './Shared';

function Groups({}) {
  const snap = useSnapshot(optimizationState);

  const groupsUsed = useMemo(() => {
    if (!snap.groups) return [];

    const orderedGroups = _.orderBy(_.uniq(snap.groups), (o) => o, ['asc']);
    return orderedGroups;
  }, [snap.groups]);

  return (
    <div className={cn('tw-mx-auto tw-max-w-2xl')}>
      <Card className="">
        <CardBody>
          <Table hover striped bordered className="tw-table-auto">
            <thead>
              <tr>
                <th>Group</th>
                <th>Group Name</th>
                <th>Min Weight %</th>
                <th>Max Weight %</th>
              </tr>
            </thead>
            <tbody>
              {groupsUsed.map((grp, i) => {
                return (
                  <tr key={`${grp}-${i}`}>
                    <td>{grp}</td>
                    <td>
                      <FormGroup className="mb-0">
                        <Input
                          type="text"
                          value={snap.groupNames[grp]}
                          onChange={(event) => {
                            const groupNames = { ...snap.groupNames };
                            groupNames[grp] = event.target.value;
                            optimizationState.groupNames = groupNames;
                          }}
                          onWheel={(event) => {
                            event.target?.blur();
                            event.currentTarget?.blur();
                          }}
                        />
                      </FormGroup>
                    </td>
                    <td>
                      <FormGroup className="mb-0">
                        <Input
                          type="number"
                          min={0}
                          max={100}
                          value={snap.groupMinWeights[grp] ?? 0}
                          onChange={(event) => {
                            const groupMinWeights = { ...snap.groupMinWeights };
                            groupMinWeights[grp] = parseNumericValue(event.target.value);
                            optimizationState.groupMinWeights = groupMinWeights;
                          }}
                          onWheel={(event) => {
                            event.target?.blur();
                            event.currentTarget?.blur();
                          }}
                        />
                      </FormGroup>
                    </td>
                    <td>
                      <FormGroup className="mb-0">
                        <Input
                          type="number"
                          min={0}
                          max={100}
                          value={snap.groupMaxWeights[grp] ?? 100}
                          onChange={(event) => {
                            const groupMaxWeights = { ...snap.groupMaxWeights };
                            groupMaxWeights[grp] = parseNumericValue(event.target.value);
                            optimizationState.groupMaxWeights = groupMaxWeights;
                          }}
                          onWheel={(event) => {
                            event.target?.blur();
                            event.currentTarget?.blur();
                          }}
                        />
                      </FormGroup>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
}

export default Groups;
